export const strings = {
  case: 'Case',
  question: 'Question',
  case_question: 'Case/Question',
  type: 'Type',
  visibility: 'Visibility',
  publish: 'Publish',
  published: 'Published',
  edit_case: 'Edit Case',
  edit_draft: 'Edit Draft',
  new_case: 'New Case',
  speciality_placeholder: 'Choose Speciality',
  save_as_draft: 'Save As Draft',
  archive_case: 'Archive Case',
  title: 'Edit title',
  title_placeholder: 'Enter title',
  speciality: 'Speciality',
  brief: 'Brief',
  brief_placeholder: 'Write here...',
  tags: 'Tags (Add tags to help us show you relevant search results)',
  mentions: 'Mentions',
  add_mention: 'Add Mention',
  add_tag: 'Add tags',
  source: 'Source',
  all_specialities: 'All Specialities',
  source_placeholder: 'Paste URL link here and/or upload an attachment',
  search_placeholder: 'Search Cases',
  disclaimer: 'Disclaimer',
  disclaimer_desc:
    'Use of patient’s personal information not limited to gender & age is against confidentiality policy & IQVIA takes no responsibility if you violate the policy.',
  age: 'Patient’s Age',
  age_placeholder: 'Enter age (e.g. 52)',
  gender_only: 'Gender',
  gender: 'Patient’s Gender',
  mention_people: 'Mention Peoples : ',
  genderList: {
    female: 'Female',
    male: 'Male',
    other: 'Other',
    NA: 'Not Specified',
  },
  optional: 'Optional',
  errors: {
    age_max: 'Age should not be greater than 150',
    cover_required: 'You need to upload case cover image',
    cover_uploading: 'Cover is being uploaded',
    title_required: 'Case Title is required',
    title_min_length: 'Case title has to be min 3 characters',
    title_max_length: 'Case title cannot be more than 250 characters',
    brief_required: 'Case Brief is required',
    brief_min_length: 'Case Brief has to be min 3 characters',
    brief_max_length: 'Case Brief cannot be more than 250 characters',
    source_url: 'Source should be valid URL',
    age_number: 'Age should always be a number',
    age_min: 'Age should be greater then zero',
    source_max_limit: 'Source cannot be more than 300 characters',
    description_required: 'Case description is required',
    description_min_length: 'Case description has to be min 3 characters',
    description_max_length:
      'Case description cannot be more than 2500 characters',
    speciality_id_required: 'Please choose a speciality',
    is_required: 'is required',
    case_title_error: 'Case title has to be 8 characters or longer',
    type_required: 'Type is required',
    race_required: 'Race is required',
    age_required: 'Age is required',
  },
  case_title: 'Cases /Questions',
  all_case: 'All Cases /Questions',
  need_help: 'Need help with a Case?',
  following_cases: 'Following Cases',
  review_cases: 'Review',
  my_cases: 'My Cases /Questions',
  publish_case: 'Publish a Case',
  view: 'Views',
  follow: 'Following',
  like: 'liked',
  cancel: 'Cancel',
  comment: 'comments',
  delete_draft: 'Delete Draft',
  draft: 'Drafts',
  discard_changes: 'Discard Changes',
  delete_case: 'Delete Case',
  delete_Draft: 'Delete Draft',
  cases_by: 'Cases By {name}',
  unarchived: 'Unarchive',
  archived_button: 'Archived',
  archived: 'Archive',
  edit: 'Edit',
  see_all_cases: 'See all {num} cases',
  published_ago: 'Created {date}',
  published_on: 'Published on {date}',
  last_published: 'Last updated {date}',
  last_archived: 'Archived on {date}',
  num_attachments: '{num} Attachment',
  saving_changes_confirmation:
    'Are you sure you want to go back without saving changes?',
  saving_changes_confirmation_desc:
    'You have unsaved changes. You will lose all recent changes and this action cannot be reversed',
  delete_case_confirm: 'Are you sure you want to delete?',

  invite_commenters: 'Invite Commenter(s)',
  invite_commenters_desc: 'Invite other users to comment on this case',
  add_members: 'Add Member(s)',
  add_coowners_desc: 'add another HCPs who can contribute to this case',
  case_owner: 'Case Owner',
  case_member: 'Case Member(s)',
  case_disclaimer_body:
    'Any patient identifiable information shall not be displayed, uploaded or distributed through the Platform. Platform’s users who provide any patient identifiable information assume the full responsibility for complying with the applicable local data privacy laws and shall be responsible for obtaining and maintaining any notices, consents or approvals necessary to make such information available to others.',

  case_disclaimer_body_2:
    'If you find any patient identifiable information being shared on the Platform or have any other concern over the content of the Platform, we request you to please report this to the Platform team on DLE-HCPSupport@imshealth.com.',
  case_disclaimer_body_3:
    'I confirm that this submission is anonymized to ensure patient confidentiality is not being compromised.',

  case_disclaimer_body_3_1:
    'No data from any case or questions can be used outside this platform.',

  case_disclaimer_body_4:
    'Submissions once shared cannot edited. Please press Cancel if you need to make any changes',
  request_to_publish: 'Request to publish',
  submit: 'Submit',
  rate_case: 'Rate Case/Question',
  rate_case_description:
    'How well were your concerns addressed in this discussion?',
  recommend_pfizer: 'Would you recommend CAVI to other HCPs',
  improvement_recommendations: 'Any recommendations for improvement?',
  call: 'Schedule a call',
  call_header: '* Available in the mobile app',
  call_description:
    'Set-up a call to discuss with the nominated experts and other participants of this case. You may use the case comments to fix the meeting time.',
  close: 'Close',
  open: 'Open',
  comments: 'Comments',
  panel_members: 'Panel Members',
  // case_details: 'Case/ Question Details',
  go_back: 'Go back',
  closure_reason: 'Resolution Note',
  yes: 'Yes',
  no: 'No',
  next: 'Next',
  select_reason: 'Select a reason',
  resolve_case: 'Close Case/Question',
  case_duplication:
    'By clicking this button, this case may be duplicated and shared with all registered CAVi users.',
  case_owner_permission:
    'Permission from the case owner is required before sharing any case details. Unauthorized sharing of case information is strictly prohibited',
  case_question_public: 'Make this case/question public',
  case_public: 'Make the case public',
  avail_before_submission:
    'Please be aware that the option to add or create a team for your case or question is only available before the submission. However, you have the flexibility to add any member at any stage to your case or question',
  create_team: 'Create Team',
  select_all: 'Select all',
  case_statuses: {
    posted: 'Posted',
    returned: 'Returned',
    pending: 'Pending',
    rejected: 'Rejected',
    save_as_draft: 'Saved as draft',
    in_review: 'In Review',
    archived: 'Archived',
    closed: 'Closed',
    open: 'Open',
  },
  status_messages: {
    screening: 'Thank you for your submission',
    draft: ' A Preview of the Case/Question before submission',
    open: 'This Case/Question is open for discussion ( Open )',
    close: 'This Case/Question is closed ( Closed )',
    returned: 'This Case/Question has been returned',
  },
  add_member_to_case: 'You can add other HCPs to contribute to this case',
  races: {
    Asian: 'Asian',
    Caucasian: 'Caucasian',
    Black: 'Black',
    Oriental: 'Oriental',
    Hispanic: 'Hispanic',
    ['African American']: 'African Americanı',
    Other: 'Other',
    ['Missing/Unknown']: 'Missing/Unknown',
  },
  patient_race: 'Ethnicity',
  request_review: 'Request a Review by our Experts Panel',
  return_case: 'Return Case',
  rejection_reason: 'Rejection Reason',
  created_On: 'Created on',
  case_id: 'Case ID',
  patient_initially_diagnosed_on: 'Patient initially diagnosed on',
  yrs_old: 'years old',
  case_question_comments: 'Case/Question Comments',
  request_review_confirmation:
    'By ticking this box our expert panel will be reviewing your Case/Question',
  commenter: 'Commenter',
  comment_id: 'Comment Id',
  mark_as_screened: 'Mark as Screened',
  report: 'Report',
  report_for_an_adverse_event: 'Report for an adverse event',
  adverse_event_reason_placeholder: "Why do you think it's an adverse event?",
  screened: 'Screened',
  case_in: 'This case is in the',
  stage: 'stage',
  return_message: 'Return message...',
  return: 'Return',
  reported: 'Reported',
  loading: 'Loading ...',
  patient_basic_info: 'Patient’s Basic Info',
  search_For: 'Search for...',
  submit_for_review: 'Submit for review',
  create_team_panel: 'Create Team Panel',
  team_name: 'Team Name',
  add_team_member: 'Add Team Member',
  no_team_notice: 'There are no users in this team yet',
  team_member_alert: 'teams should consist of at least 2 users',
  team_name_alert: 'team name should be longer than 5 characters',
  no_team_alert: 'you should atleast add two users to a team',
  deleting_team: 'Deleting team',
  deleting_team_message: 'Delete your created team from the created list',
  share_case: 'Share case',
  with_cavi_community: 'with CAVI community',
  share_case_alert: 'Writing why the case is being shared is mandatory',
  case_close_reasons: {
    resolved: 'Case/Question Resolved',
    dummy: 'Dummy Case/Question',
    rejected: 'Incorrect Details',
  },
  review_comments: 'Review Comments',
  dicom_modal_title: 'Dicom Viewer',
};
